var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBahrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 37,
    viewBox: "0 0 51 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.0888672,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.175781 0.0888672H16.9758V36.0889H0.175781V0.0888672ZM16.9758 0.0888672L21.7758 3.68887L16.9758 7.28887V0.0888672ZM16.9758 7.28887L21.7758 10.8889L16.9758 14.4889V7.28887ZM16.9758 14.4889L21.7758 18.0889L16.9758 21.6889V14.4889ZM16.9758 21.6889L21.7758 25.2889L16.9758 28.8889V21.6889ZM16.9758 28.8889L21.7758 32.4889L16.9758 36.0889V28.8889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88153"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.175781,
    y: 0.0888672,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahrain);
export default __webpack_public_path__ + "static/media/Bahrain.6dad4d30f99433e94b7442ded5babb14.svg";
export { ForwardRef as ReactComponent };